export const initialState = {
  id: null,
  name: "",
  accountLabel: "",
  accountsMap: {},
};
